import { DetailsComponent } from './details.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ DetailsComponent });
